import request from '@/utils/request'

//左侧菜单列表接口
export function getMenuSelco() {
    return request({
        url: '/ocs-auth/menu/select/common',
        method: 'get',
    })
}

//左侧菜单新建保存接口
export function getMenuSaves(data) {
    return request({
        url: '/ocs-auth/menu/save',
        method: 'post',
        data
    })
}

//左侧菜单修改保存接口
export function getMenuUpdates(data) {
    return request({
        url: '/ocs-auth/menu/update',
        method: 'post',
        data
    })
}

//左侧菜单修改保存接口
export function getMenuDeletes(id) {
    return request({
        url: `/ocs-auth/menu/delete/${id}`,
        method: 'get',
    })
}

//自定义菜单接口
export function getMenuBranCustom(id) {
    return request({
        url: `/ocs-auth/menu/select/brand/custom/${id}`,
        method: 'get',
    })
}

// 更新菜单排序
export function menuUpdateSort(data){
    return request({
        url: `/ocs-auth/menu/update/sort`,
        method: 'post',
        data
    })
}

// 角色列表
export function roleList(data) {
    return request({
        url: `/ocs-auth/role/select`,
        method: 'post',
        data:data
    })
}

// 更新角色-菜单权限
export function roleUpdateMenu(data) {
    return request({
        url: `/ocs-auth/role/update/menu`,
        method: 'post',
        data:data
    })
}